import Lottie from '@novemberfiveco/lottie-react-light';

import confettiSm from '../../assets/animations/confetti.json';
import confettiLeft from '../../assets/animations/confetti-small-left.json';
import confettiRight from '../../assets/animations/confetti-small-right.json';
import confettiTop from '../../assets/animations/confetti-small-top.json';
import styles from './Confetti.module.css';

export default function Confetti() {
  return (
    <div className={styles.container}>
      <div className={styles.confettiSm}>
        <Lottie animationData={confettiSm} loop={false} />
      </div>
      <div className={styles.confettiNormal}>
        <Lottie animationData={confettiTop} loop={false} />
        <div className={styles.sides}>
          <Lottie animationData={confettiLeft} loop={false} />
          <Lottie animationData={confettiRight} loop={false} />
        </div>
      </div>
    </div>
  );
}
